// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46e21837","239":"2a74059f","732":"fc41106d"}[chunkId] + ".chunk.js";
};